import React from 'react';
import './investment info.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { message } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { hasValue } from "../../validations/validations";


class InvestmentInfo extends React.Component {
    state = {
        actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
        id: this.props.location.state.data.id,
        status: this.props.location.state.data.status,
        revenue: this.props.location.state.data.revenue,
        revenueRatio: this.props.location.state.data.revenueRatio,
        paidInstallments: this.props.location.state.data.paidInstallments,
        settlementPrice: this.props.location.state.data.settlementPrice,
        newCost: this.props.location.state.data.newCost,
        oldCost: this.props.location.state.data.oldCost,
        advertisement: this.props.location.state.data.advertisement ? this.props.location.state.data.advertisement : null,
        buyer: this.props.location.state.data.buyer ? this.props.location.state.data.buyer : null,
        owner: this.props.location.state.data.owner ? this.props.location.state.data.owner : null,
        pages: 1,
        page: 1,
        modalForComplete: false,
        client: '',
        contractFile: null,
        contractFileType: 'data',
        contractFileName: [],
        recieptFile: null,
        recieptFileType: 'data',
        recieptFileName: [],
    };

    constructor(props) {
        super(props)
        window.scrollTo(0, 0)
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }

    componentDidMount() {
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }
    delete = () => {
        let l = message.loading('Wait..', 2.5)
        axios.delete(`${BASE_END_POINT}investments/${this.props.location.state.data.id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            },
        })
            .then(response => {
                console.log("Transaction DELETED")
                l.then(() => message.success(allStrings.done, 2.5))
                this.props.history.goBack()
            })
            .catch(error => {
                console.log(error.response)
                l.then(() => message.error(allStrings.error, 2.5))
            })
    }
    cancel = () => {
        let l = message.loading('Wait..', 2.5)
        axios.put(`${BASE_END_POINT}investments/${this.props.location.state.data.id}/cancel`, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en',
            },
        })
            .then(response => {
                console.log("investment cancel")
                l.then(() => message.success(allStrings.done, 2.5))
                this.props.history.goBack()
            })
            .catch(error => {
                console.log(error.response)
                l.then(() => message.error(allStrings.error, 2.5))
            })
    }
    accept = () => {
        const { newCost, revenue, revenueRatio } = this.state
        if (newCost > 0 && revenue > 0 && revenueRatio > 0) {
            let l = message.loading('Wait..', 2.5)
            let data = {
                'newCost': newCost,
                'revenue': revenue,
                'revenueRatio': revenueRatio,
            }
            axios.put(`${BASE_END_POINT}investments/${this.props.location.state.data.id}/accept`, JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'Accept-Language': this.props.isRTL ? 'ar' : 'en'
                },
            })
                .then(response => {
                    l.then(() => message.success(allStrings.done, 2.5))
                    this.toggleForAccept()
                    this.props.history.goBack()
                })
                .catch(error => {
                    console.log(error.response)
                    l.then(() => message.error(allStrings.error, 2.5))
                })
        }
    }
    submitHandlerAccept = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.accept()
    };
    toggleForAccept = () => {
        this.setState({
            modalForAccept: !this.state.modalForAccept,
        });
    }
    modalForAccept = () => (
        <MDBModal isOpen={this.state.modalForAccept} toggle={this.toggleForAccept} size="lg">
            <MDBModalHeader toggle={this.toggleForComplete} >{allStrings.completeData}</MDBModalHeader>
            <MDBModalBody>
                <MDBContainer>
                    <MDBRow>
                        <MDBCol md="12">
                            <form style={{ paddingTop: '1rem' }}
                                className="needs-validation"
                                onSubmit={this.submitHandlerAccept}
                                noValidate
                            >
                                <div className="grey-text">
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                                <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.newCost}</label>
                                                <br></br>
                                                <input value={this.state.newCost} name="newCost" onChange={this.changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="number" min={0} id="form920" className="form-control" validate required placeholder="أدخل الرقم..." />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                                <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.revenue}</label>
                                                <br></br>
                                                <input value={this.state.revenue} name="revenue" onChange={this.changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="number" min={0} id="form920" className="form-control" validate required placeholder="أدخل الرقم..." />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                                <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.revenueRatio}</label>
                                                <br></br>
                                                <input value={this.state.revenueRatio} name="revenueRatio" onChange={this.changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="number" min={0} id="form920" className="form-control" validate required placeholder="أدخل الرقم..." />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                </div>
                                <div className="drawer-action-footer">
                                    <MDBBtn type="button" className="btn-cancel" onClick={this.toggleForAccept}>
                                        إلغاء
                                    </MDBBtn>
                                    <MDBBtn type="submit" className="btn-submit">
                                        {allStrings.send}
                                    </MDBBtn>
                                </div>
                            </form>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </MDBModalBody>
        </MDBModal>
    );
    complete = () => {
        const { client, contractFile, recieptFile } = this.state
        if (hasValue(client)) {
            let l = message.loading('Wait..', 2.5)
            let data = new FormData()
            data.append('advertisement', this.state.id)
            data.append('client', client)
            if (contractFile != null) {
                data.append(`contractFile`, contractFile)
            }
            if (recieptFile != null) {
                data.append(`recieptFile`, recieptFile)
            }
            axios.put(`${BASE_END_POINT}investments/${this.props.location.state.data.id}/complete`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'Accept-Language': this.props.isRTL ? 'ar' : 'en'
                },
            })
                .then(response => {
                    l.then(() => message.success(allStrings.done, 2.5))
                    this.toggleForComplete()
                    this.props.history.goBack()
                })
                .catch(error => {
                    console.log(error.response)
                    l.then(() => message.error(allStrings.error, 2.5))
                })
        }
    }
    submitHandlerComplete = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.complete()
    };
    toggleForComplete = () => {
        this.setState({
            modalForComplete: !this.state.modalForComplete,
        });
    }
    modalForComplete = () => (
        <MDBModal isOpen={this.state.modalForComplete} toggle={this.toggleForComplete} size="lg">
            <MDBModalHeader toggle={this.toggleForComplete} >{allStrings.completeData}</MDBModalHeader>
            <MDBModalBody>
                <MDBContainer>
                    <MDBRow>
                        <MDBCol md="12">
                            <form style={{ paddingTop: '1rem' }}
                                className="needs-validation"
                                onSubmit={this.submitHandlerComplete}
                                noValidate
                            >
                                <div className="grey-text">
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                                <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.client}</label>
                                                <br></br>
                                                <input name="client" onChange={this.changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="number" min={0} id="form920" className="form-control" validate required placeholder="أدخل الرقم..." />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="fileUpload2">
                                                <input key={this.state.contractFile} type='file' className="upImgs2" onChange={this.fileChangedHandlerContractFile} ></input>
                                                <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.contractFile}</span></span>
                                            </div>
                                            <div className="preview">
                                                {this.state.contractFile &&
                                                    <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                                        <img alt="" src={URL.createObjectURL(this.state.contractFile)} className="previewImg2" />

                                                        <span className="imgName">{this.state.contractFileName}</span>
                                                        <MDBIcon icon="trash" className="mr-2 removeImg2"
                                                            onClick={() => this.removeContractFile()}  ></MDBIcon>
                                                    </div>
                                                }
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="fileUpload2">
                                                <input key={this.state.recieptFile} type='file' className="upImgs2" onChange={this.fileChangedHandlerRecieptFile} ></input>
                                                <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.recieptFile}</span></span>
                                            </div>
                                            <div className="preview">
                                                {this.state.recieptFile &&
                                                    <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                                        <img alt="" src={URL.createObjectURL(this.state.recieptFile)} className="previewImg2" />

                                                        <span className="imgName">{this.state.recieptFileName}</span>
                                                        <MDBIcon icon="trash" className="mr-2 removeImg2"
                                                            onClick={() => this.removeRecieptFile()}  ></MDBIcon>
                                                    </div>
                                                }
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                </div>
                                <div className="drawer-action-footer">
                                    <MDBBtn type="button" className="btn-cancel" onClick={this.toggleForComplete}>
                                        إلغاء
                                    </MDBBtn>
                                    <MDBBtn type="submit" className="btn-submit">
                                        {allStrings.send}
                                    </MDBBtn>
                                </div>
                            </form>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </MDBModalBody>
        </MDBModal>
    );
    fileChangedHandlerContractFile = event => {
        this.setState({
            contractFile: event.target.files[0],
            contractFileName: event.target.files[0].name,
            contractFileType: "data"
        })
    }
    removeContractFile = () => {
        this.setState({
            contractFile: null,
            contractFileName: '',
            contractFileType: "url"
        });
    }
    fileChangedHandlerRecieptFile = event => {
        this.setState({
            recieptFile: event.target.files[0],
            recieptFileName: event.target.files[0].name,
            recieptFileType: "data"
        })
    }
    removeRecieptFile = () => {
        this.setState({
            recieptFile: null,
            recieptFileName: '',
            recieptFileType: "url"
        });
    }
    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
    };

    changeHandler = event => {
        const { name, value } = event.target;
        const { oldCost } = this.state;

        if (name === "newCost") {
            const revenue = value - oldCost;
            let revenueRatio = oldCost !== 0 ? (revenue / oldCost) * 100 : 0;
            revenueRatio = revenueRatio.toFixed(1)
            this.setState({
                newCost: value,
                revenue,
                revenueRatio,
            });
        } else {
            this.setState({ [name]: value });
        }
    };

    render() {
        if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('ADS')) return <Redirect to='/Home' />

        return (
            <div className="App">
                <MDBContainer>
                    {this.state.actionType === "VIEW" &&
                        <MDBRow style={{ flexFlow: this.props.isRTL ? 'row-reverse' : 'row' }} >
                            <MDBCol md='12'>
                                <MDBBtn onClick={() => { this.delete() }} rounded style={{ display: 'inline-block', width: 'fit-content', margin: '8px', background: 'linear-gradient(135deg, #FF3547, #B71C1C)', color: '#fff', borderRadius: '10px' }} color="FF3547" className="btn-block z-depth-1a">
                                    <MDBIcon icon="trash-alt" className="mr-2" />
                                    {allStrings.remove}
                                </MDBBtn>
                                {this.state.status === "PENDING" &&
                                    <MDBBtn
                                        onClick={() => { this.toggleForAccept() }}
                                        color="none"
                                        style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}
                                        rounded
                                        className="btn-block z-depth-1a"
                                    >
                                        {allStrings.accept}

                                    </MDBBtn>

                                }
                                {this.state.status === "PENDING" &&
                                    <MDBBtn
                                        onClick={() => { this.cancel() }}
                                        color="none"
                                        style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}

                                        rounded
                                        className="btn-block z-depth-1a"
                                    >
                                        {allStrings.cancel}

                                    </MDBBtn>

                                }
                                {this.state.status === "ON-PROGRESS" &&
                                    <MDBBtn
                                        onClick={() => { this.toggleForComplete() }}
                                        color="none"
                                        style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}

                                        rounded
                                        className="btn-block z-depth-1a"
                                    >
                                        {allStrings.completed}

                                    </MDBBtn>

                                }
                            </MDBCol>
                        </MDBRow>
                    }
                    <MDBRow>
                        {this.modalForAccept()}
                        {this.modalForComplete()}
                        <MDBCol md="12" >
                            <div className="infoCard">
                                <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                                    <CardMedia
                                        style={{ height: "0px" }}
                                    />
                                    <CardHeader></CardHeader>
                                    <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                                        <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                                            <span className="material-icons" style={{ color: 'white', fontSize: 23 }}>attach_money</span>
                                        </div>
                                        <div className="tableTitle" style={{
                                            display: 'inline-block', marginTop: '-60px',
                                            marginLeft: '0', marginRight: '0'
                                        }}>
                                            <p>{this.state.actionType === "VIEW" ? allStrings.info : allStrings.edit}</p>
                                        </div>
                                    </div>
                                    <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                                        <MDBContainer>

                                            <MDBRow>
                                                <MDBCol md="12">
                                                    <form
                                                        className="needs-validation"
                                                        onSubmit={this.submitHandler}
                                                        noValidate
                                                    >

                                                        <div className="grey-text">
                                                            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>#</label>
                                                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.id} type="text" id="form8" className="form-control" onChange={this.changeHandler} validate />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form56" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.status}</label>
                                                                        <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.status === "PENDING" ? allStrings.pending : this.state.status === "ON-PROGRESS" ? allStrings.active : this.state.status === "CANCELED" ? allStrings.canceled : allStrings.completed} type="text" id="form56" name="status" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل البيانات..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.oldCost}</label>
                                                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.oldCost} type="text" id="form8" className="form-control" onChange={this.changeHandler} validate />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.paidInstallments}</label>
                                                                        <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.paidInstallments} type="text" id="form645" name="paidInstallments" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل البيانات..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>

                                                            </MDBRow>

                                                            <MDBRow>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.settlementPrice}</label>
                                                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.settlementPrice} type="text" id="form8" className="form-control" onChange={this.changeHandler} validate />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.newCost}</label>
                                                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.newCost} type="text" id="form8" className="form-control" onChange={this.changeHandler} validate />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            <MDBRow>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.revenue}</label>
                                                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.revenue} type="text" id="form8" name='revenue' className="form-control" onChange={this.changeHandler} validate />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.revenueRatio}</label>
                                                                        <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.revenueRatio} type="text" id="form645" name="revenueRatio" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل البيانات..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            {this.state.advertisement &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="10" xs="10">
                                                                        <div class="md-form">
                                                                            <label htmlFor="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.theAdveristment}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.advertisement ? this.state.advertisement.title : 'مشاهده الاعلان'} type="text" id="form80" class="form-control" />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="2" xs="2">

                                                                        <p style={{ textAlign: 'center', marginTop: '2.3rem', color: '#2BBBAD' }}>
                                                                            <span style={{ cursor: 'pointer', position: 'absolute', padding: '3px' }} class="material-icons"
                                                                                onClick={() => { this.props.history.push('adsInfo', { data: { id: this.state.advertisement.id } }) }}>
                                                                                remove_red_eye
                                                                            </span>
                                                                            <span style={{ cursor: 'pointer', fontSize: '16px', fontWeight: '500', marginLeft: '2rem' }}
                                                                                onClick={() => { this.props.history.push('adsInfo', { data: { id: this.state.advertisement.id } }) }}>
                                                                                {allStrings.show}
                                                                            </span>
                                                                        </p>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }
                                                            {this.state.owner &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="5" xs="5">
                                                                        <div class="md-form">
                                                                            <label htmlFor="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.owner}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.owner ? this.state.owner.fullname : ''} type="text" id="form80" class="form-control" />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="5" xs="5">
                                                                        <div class="md-form">
                                                                            <label htmlFor="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.phone}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.owner ? this.state.owner.phone : ''} type="text" id="form80" class="form-control" />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="2" xs="2">

                                                                        <p style={{ textAlign: 'center', marginTop: '2.3rem', color: '#2BBBAD' }}>
                                                                            <span style={{ cursor: 'pointer', position: 'absolute', padding: '3px' }} class="material-icons"
                                                                                onClick={() => { this.props.history.push('userInfo', { data: this.state.owner }) }}>
                                                                                remove_red_eye
                                                                            </span>
                                                                            <span style={{ cursor: 'pointer', fontSize: '16px', fontWeight: '500', marginLeft: '2rem' }}
                                                                                onClick={() => { this.props.history.push('userInfo', { data: this.state.owner }) }}>
                                                                                {allStrings.show}
                                                                            </span>
                                                                        </p>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }
                                                            {this.state.buyer &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="5" xs="5">
                                                                        <div class="md-form">
                                                                            <label htmlFor="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.buyer}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.buyer ? this.state.buyer.fullname : ''} type="text" id="form80" class="form-control" />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="5" xs="5">
                                                                        <div class="md-form">
                                                                            <label htmlFor="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.phone}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.buyer ? this.state.buyer.phone : ''} type="text" id="form80" class="form-control" />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="2" xs="2">

                                                                        <p style={{ textAlign: 'center', marginTop: '2.3rem', color: '#2BBBAD' }}>
                                                                            <span style={{ cursor: 'pointer', position: 'absolute', padding: '3px' }} class="material-icons"
                                                                                onClick={() => { this.props.history.push('userInfo', { data: this.state.buyer }) }}>
                                                                                remove_red_eye
                                                                            </span>
                                                                            <span style={{ cursor: 'pointer', fontSize: '16px', fontWeight: '500', marginLeft: '2rem' }}
                                                                                onClick={() => { this.props.history.push('userInfo', { data: this.state.buyer }) }}>
                                                                                {allStrings.show}
                                                                            </span>
                                                                        </p>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }


                                                        </div>
                                                    </form>
                                                </MDBCol>
                                            </MDBRow>
                                        </MDBContainer>
                                    </CardContent>
                                </Card>
                            </div>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </div>
        )
    }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(InvestmentInfo)
);
